<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Your Request</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%">
        <CCol sm="12" class="mt-5">
          <span class="float-right mt-4" @click="GoToPageFindTutor()">
            <label>Add New List</label> &nbsp;
            <img src="../assets/img/iconAdd.png" width="35px" />
          </span>
        </CCol>
      </div>
      <div class="mt-5"><br /><br /><br /><br /><br /></div>
    </div>

    <CCard
      style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px"
      class="custom-card h-100 full-height"
    >
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin m-0 p-0">
            <br />
            <label>
              <img
                src="../assets/img/iconInfo.png"
                width="20px"
                height="20px"
              />
              This is the list of available student to pair. Please Select Any
              One Of this Waiting List Student. Make sure you have same subject
              and grade before request to pair. If not, please fill up new form
              for group of two by choosing “Add new list” menu above.
            </label>
            <!-- <v-select
                class="mt-2"
                v-model="SelectedSubject"
                :options="subjects"
                label="SubjectName"
                placeholder="Search Subject"
              ></v-select> -->

            <CSelect
              class="mt-2"
              placeholder="Search Subject"
              :value.sync="SelectedSubject"
              :options="subjectsOptions"
              @change="FilteredWaiting()"
            />

               <CSelect
              class="mt-2"
              placeholder="Search Level/Grade"
              :value.sync="SelectedGrade"
              :options="gradesOptions"
              @change="FilteredGrade()"
            />

            <!-- <v-select
              class="mt-2"
              v-model="SelectedGrade"
              :options="grades"
              label="GradeName"
              placeholder="Search Level/Grade"
            ></v-select> -->
            <!-- <CButton
              color="outline-success"
              class="my-2 my-sm-0 float-right"
              type="submit"
              @click="Search()"
              >Search</CButton> -->
            <br /><br />
            <hr />

            <div
              v-for="(item, index) in FilteredWaitings"
              v-bind:key="item.StudentId"
              v-bind:class="{ 'lb_ext-active': currentAccordion === index }"
            >
              <!-- Sini akan display info pasal student tu sendiri -->
              <div v-if="item.StudentId == StudentId">
                <CCard
                  style="
                    background-color: #ffffff;
                    border-color: #cccccc;
                    border-radius: 20px;
                    margin-bottom: 15px;
                  "
                  class="col-12"
                >
                  <CRow style="margin-top: 10px">
                    <CCol class="col-8">
                      <strong
                        ><p style="font-size: 16px; margin-bottom: 0px">
                          You {{ item.Name }}
                        </p></strong
                      >
                      <CRow class="col-12">
                        <p style="margin-bottom: 0px; margin-left: 10px">
                          - subject:
                        </p>
                        <p
                          style="
                            font-weight: 700;
                            margin-bottom: 0px;
                            margin-left: 5px;
                          "
                        >
                          {{ item.SubjectName }}
                        </p>
                      </CRow>
                      <CRow class="col-12">
                        <p style="margin-bottom: 0px; margin-left: 10px">
                          - grade:
                        </p>
                        <p
                          style="
                            font-weight: 700;
                            margin-bottom: 0px;
                            margin-left: 5px;
                          "
                        >
                          {{ item.GradeName }}
                        </p>
                      </CRow>
                      <CRow class="col-12">
                        <p style="margin-bottom: 0px; margin-left: 10px">
                          - time:
                        </p>
                        <p style="font-weight: 700; margin-left: 5px">
                          {{ item.Session }}
                        </p>
                      </CRow>
                    </CCol>
                  </CRow>
                </CCard>
              </div>

              <!-- Sini akan display info pasal student lain -->
              <div v-else>
                <div id="accordion">
                  <CCard
                    style="
                      background-color: #ffffff;
                      border-color: #cccccc;
                      border-radius: 20px;
                      margin-bottom: 15px;
                    "
                    class="col-12"
                  >
                    <CRow style="margin-top: 10px">
                      <CCol class="col-8">
                        <strong
                          ><p style="font-size: 16px; margin-bottom: 0px">
                            {{ item.Name }}
                          </p></strong
                        >
                        <CRow class="col-12">
                          <p style="margin-bottom: 0px; margin-left: 10px">
                            - subject:
                          </p>
                          <p
                            style="
                              font-weight: 700;
                              margin-bottom: 0px;
                              margin-left: 5px;
                            "
                          >
                            {{ item.SubjectName }}
                          </p>
                        </CRow>
                        <CRow class="col-12">
                          <p style="margin-bottom: 0px; margin-left: 10px">
                            - grade:
                          </p>
                          <p
                            style="
                              font-weight: 700;
                              margin-bottom: 0px;
                              margin-left: 5px;
                            "
                          >
                            {{ item.GradeName }}
                          </p>
                        </CRow>
                        <CRow class="col-12">
                          <p style="margin-bottom: 0px; margin-left: 10px">
                            - time:
                          </p>
                          <p style="font-weight: 700; margin-left: 5px">
                            {{ item.Session }}
                          </p>
                        </CRow>
                      </CCol>
                      <CCol class="col-4">
                        <div
                          style="
                            margin-top: 30px;
                            margin-left: 0px;
                            margin-right: 0px;
                          "
                        >
                          <CButton
                            style="
                              background-color: #20ca64;
                              color: #ffffff;
                              border-radius: 15px;
                              font-weight: bold;
                             text-align: center;
                              margin: auto;
                              white-space: pre;
                                  width: auto;
                            "
                            block
                            :disabled="isDisabled"
                            v-on:click="JoinClick(index)"
                            v-html="join"
                          ></CButton>
                        </div>
                      </CCol>
                    </CRow>
                  </CCard>
                </div>
                <transition
                  mode="out-in"
                  name="faq-fade"
                  v-on:before-enter="beforeEnterAcc"
                  v-on:enter="enterAcc"
                >
                  <div
                    v-show="currentAccordion === index"
                    style="margin-left: 60px; width: 70%; padding-bottom: 50px"
                  >
                    <h5>{{ confirm }}</h5>
                    <div>
                      <CCol>
                        <span class="float-right col-5">
                          <CButton
                            style="
                              background-color: #ff3a3a;
                              color: #ffffff;
                              border-radius: 15px;
                              font-weight: bold;
                            "
                            block
                            size="md"
                            :disabled="isDisabled"
                            @click="JoinNo()"
                            >No</CButton
                          >
                        </span>
                        <span class="float-right col-5">
                          <CButton
                            style="
                              background-color: #20ca64;
                              color: #ffffff;
                              border-radius: 15px;
                              font-weight: bold;
                            "
                            block
                            size="md"
                            :disabled="isDisabled"
                            @click="JoinYes(index)"
                            >Yes</CButton
                          >
                        </span>
                      </CCol>
                    </div>
                  </div>
                </transition>
              </div>
            </div>

            <!-- <div v-if="waiting.length > 0">
                <div>
                  <table style="width:100%">
                    <tbody>
                      <tr v-for="(item, index) in waiting" v-bind:key="item.Id">
                        <td style="width:80%">{{ item.Name }}</td>
                        <td class="float-right">
                          <CButton
                            color="success"
                            class="custom-btn"
                            block
                            @click="UpdateWaiting(index)"
                            >Select</CButton
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
              <div v-else>
                You will be in waiting list.We will choose partner for you on
                subject you are select.
                <CButton
                  color="success"
                  class="custom-btn"
                  block
                  @click="GoToPageFindTutor()"
                  >Back</CButton
                >
              </div> -->
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  el: "#accordion",
  data: function () {
    return {
      backgroundBanner,
      StudentId: 0,
      waitingListStudent: [],
      join: "Join",
      confirm: "Confirm?",
      currentAccordion: -10,
      SelectedSubject: "",
      subjects: [],
      SelectedGrade: "",
      grades: [],

      subjectsOptions: [],
      size: "",

      FilteredWaitings: [],
    };
  },
  async mounted() {
    this.GetWaitingListStudent();
    this.GetSubject();
    this.GetGrade();
  },
  methods: {
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    Search() {
      this.$router.push(
        "/ListWaiting?subjectId=" +
          this.SelectedSubject.Id +
          "&gradeId=" +
          this.SelectedGrade.Id +
          "&studentId=" +
          this.$route.query.studentId +
          "&userID=" +
          this.$route.query.userID
      );
      window.location.reload();
    },
    JoinClick: function (newAcc) {
      if (newAcc === this.currentAccordion) {
        this.currentAccordion = -10;
      } else {
        this.currentAccordion = newAcc;
      }
    },
    beforeEnterAcc: function (_t) {
      _t.style.display = "block";
      _t.style.maxHeight = null;
      _t.myHeight = _t.offsetHeight;
      _t.style.maxHeight = 0;
      _t.style.display = null;
    },
    enterAcc: function (_t) {
      _t.style.maxHeight = _t.myHeight + "px";
    },

    async GetWaitingListStudent() {
      this.$API.get(this.$WaitingListStudent).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.waitingListStudent = response.data;
          console.log(this.waitingListStudent);
          this.StudentId = this.$route.query.studentId;
          this.FilteredWaitings = this.waitingListStudent;

          var subjectNames = _.uniq(_.map(response.data, "SubjectName"));
          subjectNames.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
          this.subjectsOptions = subjectNames;
          this.subjectsOptions.unshift("ALL SUBJECT");

          var gradesNames = _.uniq(_.map(response.data, "GradeName"));
          gradesNames.sort(function (a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
          this.gradesOptions = gradesNames;
          this.gradesOptions.unshift("ALL GRADE");
        }
      });
    },

    JoinYes(index) {
      this.GoToPageTutorRequest();
      this.$dialog
        .alert({
          title: "Join Status",
          body: "You group has been created, please check at your notification for the list of tutor who are applying for this Job within today.",
          icon: "info",
        })
        .then(function (dialog) {
          console.log("Closed");
        });
      const formData = new FormData();

      formData.append("IsGroup", true);
      formData.append("WaitingListId", this.waitingListStudent[index].Id);
      formData.append("StudentId", this.$route.query.studentId);
      formData.append(
        "FindTutorId",
        this.waitingListStudent[index].FindTutorId
      );
      formData.append(
        "SubjectId",
        this.waitingListStudent[index].FindTutorSubjectId
      );
      formData.append(
        "GradeId",
        this.waitingListStudent[index].FindTutorLevelId
      );

      return this.$API
        .post(this.$StudentGrouping, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.GoToPageNotification();
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },

    JoinNo() {
      this.currentAccordion = -10;
    },

    GoToPageTutorRequest() {
      this.$router.push("/ListRequest?userId=" + this.$route.query.userID);
    },

    GoToPageFindTutor() {
      this.$router.push(
        "/CreateNewFindTutorGroup?userID=" +
          this.$route.query.userID +
          "&studentId=" +
          this.$route.query.studentId
      );
    },

    GoToPageNotification() {
      this.$router.push("/ListRequest?userId=" + this.ft.UserId);
    },

    FilteredWaiting() {
      console.log("masuk req");
      this.FilteredWaitings = this.waitingListStudent;

      if (this.SelectedSubject !== "ALL SUBJECT")
        this.FilteredWaitings = _.filter(
          this.FilteredWaitings,
          (item) => item.SubjectName === this.SelectedSubject
        );
    },
     FilteredGrade() {
      console.log("masuk req");
      this.FilteredWaitings = this.waitingListStudent;

      if (this.SelectedGrade!== "ALL GRADE")
        this.FilteredWaitings = _.filter(
          this.FilteredWaitings,
          (item) => item.GradeName === this.SelectedGrade
        );
    },
  },
};
</script>

